/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CbsLogo/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CbsLogo({
  children,
  viewPath = "/DesignSystem/Images/CbsLogo",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 80,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 1801
  
}) {
  return (<React.Fragment
>
<img
  data-testid="CbsLogo.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z2pRGyx': alignSelf,'--bc-2-Z2pRGyx': backgroundColor,'--bblr-3-Z2pRGyx': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z2pRGyx': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z2pRGyx': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z2pRGyx': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z2pRGyx': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z2pRGyx': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z2pRGyx': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z2pRGyx': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z2pRGyx': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z2pRGyx': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}